import React from 'react'
import { Box, Typography, Link as MuiLink } from '@mui/material'
import type { SourceCitation } from '@/data/research/types'

interface SourceCitationsProps {
  citations: SourceCitation[]
  disclaimer?: string
}

const SourceCitations: React.FC<SourceCitationsProps> = ({
  citations,
  disclaimer,
}) => {
  return (
    <Box component="section" sx={{ my: 4 }}>
      <Typography
        variant="h2"
        sx={{ mb: 3, fontSize: { xs: '1.35rem', md: '2.5rem' } }}
      >
        Sources &amp; Further Reading
      </Typography>
      <Box component="ol" sx={{ pl: 3 }}>
        {citations.map(citation => (
          <Box component="li" key={citation.id} sx={{ mb: 1.5 }}>
            <Typography variant="body2" component="span">
              {citation.authors}. &ldquo;{citation.title}.&rdquo;{' '}
              {citation.publication && <em>{citation.publication}, </em>}
              {citation.year}.
              {citation.url && (
                <>
                  {' '}
                  <MuiLink
                    href={citation.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    [Link]
                  </MuiLink>
                </>
              )}
            </Typography>
          </Box>
        ))}
      </Box>
      {disclaimer && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 3, fontStyle: 'italic' }}
        >
          {disclaimer}
        </Typography>
      )}
    </Box>
  )
}

export default SourceCitations
